<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          รายการแผนงานที่เปิดรับ
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="jam:world"
            ></TextField>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-space-between mb-3 px-6">
      <div
          v-for="(item, i) in tableHeader"
          :key="i"
          :style="{ 'width': item.width }"
          :class="[ 'text-' + (item.align ? item.align : 'start') ]"
      >
        {{ item.name }}
      </div>
    </div>

    <div class="list-layout">
      <AvailablePlanListItem
          v-for="(item, i) in planList"
          :key="i"
          :item="item"
          :headers="tableHeader"
          @onEdit="$router.push({ name: 'AvailablePlanListEdit', query: { id: item.id } })"
      ></AvailablePlanListItem>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import AvailablePlanListItem from "../../components/AvailablePlanListItem"

export default {
  name: "AvailablePlanList",
  components: {
    TextField,
    AvailablePlanListItem
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'รหัสแผนงาน',
          width: '8%'
        },
        {
          name: 'แผนงาน',
          width: '60%'
        },
        {
          name: 'จำนวนโครงการ',
          width: '15%',
          align: 'center'
        },
        {
          name: 'งบประมาณ',
          width: '25%',
          align: 'end'
        }
      ],
      planList: [
        // {
        //   plan_code: '#123',
        //   plan_name_th: 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์',
        //   plan_name_eng: 'Service Platform',
        // },
        // {
        //   plan_code: '#123',
        //   plan_name_th: 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์',
        //   plan_name_eng: 'Service Platform',
        // },
        // {
        //   plan_code: '#123',
        //   plan_name_th: 'แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์',
        //   plan_name_eng: 'Service Platform',
        // },
      ]
    }
  },
  created() {
    if (!this.$route.query.id) return this.$router.push({ name: 'AvailablePlan' })
    this.getProjectById(this.$route.query.id)
  },
  methods: {
    async getProjectById (id) {
      let res = await this.$apiFire('MainProject/getMainProjectById', id)
      console.log(res)
      if (res) {
        this.planList = res
      } else {
        this.$router.push({ name: 'AvailablePlan' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>